import { render, staticRenderFns } from "./BButtonDownloadExcel.vue?vue&type=template&id=74847530&scoped=true&"
import script from "./BButtonDownloadExcel.vue?vue&type=script&lang=js&"
export * from "./BButtonDownloadExcel.vue?vue&type=script&lang=js&"
import style0 from "./BButtonDownloadExcel.vue?vue&type=style&index=0&id=74847530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74847530",
  null
  
)

export default component.exports